import _ from 'lodash'
import store from '@/store'

export default {
  setBooking(state, value) {
    state.booking = value
  },

  setNullCurrentCity(state, tab) {
    store.getters.newBookings[tab].city = null
  },

  setNullCurrentUnit(state, tab) {
    store.getters.newBookings[tab].unit = null
  },

  setNullCurrentUser(state, tab) {
    store.getters.newBookings[tab].selectedUser = null
  },

  setNullCurrentMaster(state, tab) {
    store.getters.newBookings[tab].master = null
  },

  setMasterByID(state, id) {
    const employers = store.getters.employers

    state.master = _.find(employers, employer => {
      return employer.id === id
    })
  },

  setMaster(state, value) {
    state.master = value
  },

  setBookingWindows(state, value) {
    const arr = []
    value.map(function (item) {
      let str = ''
      item.windows.map(function (it) {
        str += `${it.id},`
        return true
      })
      str = str.substring(0, str.length - 1)
      arr.push({ id: str, windows: item.windows })
      return true
    })
    state.bookingWindows = arr
  },

  setBookingWindow(state, value) {
    state.bookingWindow = value
  },

  setBookingWindowByID(state, windowID) {
    if (state.bookingWindow && state.bookingWindow.id === windowID) {
      // If window already selected
      state.bookingWindow = null
    } else {
      // Select another booking
      state.bookingWindow = _.find(state.bookingWindows, bookingWindow => {
        return bookingWindow.id === windowID
      })
    }
  },

  setBookingLoad(state, value) {
    state.bookingLoad = value
  },

  setTimeBtnClicked(state, value) {
    state.timeBtnClicked = value
  },

  setBookings(state, value) {
    state.bookings = value
  },

  setBookingStatuses(state, value) {
    state.bookingStatuses = value
  },

  setBookingErrors(state, serviceErrors) {
    state.bookingErrors = serviceErrors
  },

  setBookingsFilters(state, filters) {
    state.bookingsFilters = filters
  },

  setBookingField(state, { key, value }) {
    if (state.booking) {
      state.booking[key] = value
    }
  },

  setNewBookings(state, value) {
    state.newBookings = value
  },

  setNewUserModal(state, value) {
    state.newUserModal = value
  },

  setLastBookingID(state, value) {
    state.lastBookingID = value
  },

  setNewBookingServiceCategories(state, payload) {
    if (state.newBookings[payload.item]) {
      state.newBookings[payload.item].serviceCategories = payload.serviceCategories
    }
  },

  setNewBookingJoins(state, payload) {
    const bookingIndex = payload.bookingIndex
    const joins = payload.joins

    const newBooking = state.newBookings[bookingIndex]
    if (newBooking) {
      newBooking.joins = joins
    }
  },

  setEmptyNewBookingsJoins(state, payload) {
    const bookingIndex = payload.bookingIndex
    const joins = []

    const newBooking = state.newBookings[bookingIndex]
    if (newBooking) {
      newBooking.joins = joins
    }
  },

  setSelectedUserToNewBooking(state, payload) {
    state.newBookings[payload.currentTab].selectedUser = payload.user
    if (state.newBookings[payload.currentTab].selectedUser) {
      state.newBookings[payload.currentTab].customerName = payload.user.first_name
    } else {
      state.newBookings[payload.currentTab].customerName = 'Новый клиент'
    }
  },

  deleteBooking(state, id) {
    for (let i = 0; i < state.bookings.length; i++) {
      if (state.bookings[i].id === id) {
        state.bookings.splice(i, 1)
        break
      }
    }
  },

  setMasterByIDToNewBooking(state, payload) {
    const employers = store.getters.employers

    state.newBookings[payload.item].master = _.find(employers, employer => {
      return employer.id === payload.employerID
    })
  },

  setUnitByIDToNewBooking(state, payload) {
    const units = store.getters.units

    state.newBookings[payload.item].unit = _.find(units, unit => {
      return unit.id === payload.unitID
    })
  },

  setCityToNewBooking(state, payload) {
    state.newBookings[payload.currentTab].city = payload.city
  },

  setParallelToNewBooking(state, payload) {
    state.newBookings[payload.currentTab].parallel = payload.parallel
  },

  setSpecialMasterToNewBooking(state, payload) {
    state.newBookings[payload.index].specialMaster = payload.value
  },

  addNewBooking(state, value) {
    state.newBookings.push(value)
  },

  deleteNewBooking(state, item) {
    state.newBookings.splice(item, 1)
  },

  changeBooking(state, payload) {
    for (let i = 0; i < state.bookings.length; i++) {
      if (state.bookings[i].id === payload.key) {
        state.bookings.splice(i, 1, payload.value)
        break
      }
    }
  },

  setSusseeded(state, value) {
    state.susseeded = value
  },

  selectNewBookingServiceByIndex(state, payload) {
    const bookingIndex = payload.bookingIndex
    const service = payload.service

    const newBooking = state.newBookings[bookingIndex]
    if (newBooking) {
      let serviceIndex = null

      _.forEach(newBooking.services, (item, index) => {
        if (item.id === service.id) {
          serviceIndex = index
          return false
        }
      })

      if (serviceIndex !== null) {
        newBooking.services.splice(serviceIndex, 1)
      } else {
        newBooking.services.push(service)
      }
    }
  },
  selectNewBookingJoinByIndex(state, payload) {
    const bookingIndex = payload.bookingIndex
    const join = payload.join
    const newBooking = state.newBookings[bookingIndex]
    if (newBooking) {
      _.forEach(newBooking.joins, item => {
        if (item.id !== join.id) {
          _.forEach(item.windows, item => {
            if (!_.isEqual(item, join)) {
              item.active = false
            }
          })
          item.active = false
        }
      })
      const currentJoin = _.find(newBooking.joins, item => {
        if (item.id === join.id) {
          return true
        }
      })

      if (currentJoin) {
        currentJoin.active = !currentJoin.active
      }
    }
  },

  setNewBookingJoinFieldByIndex(state, payload) {
    const bookingIndex = payload.bookingIndex
    const joinIndex = payload.joinIndex
    const joinField = payload.joinField
    const value = payload.value

    const newBooking = state.newBookings[bookingIndex]
    const join = newBooking.joins[joinIndex]
    if (join) {
      join[joinField] = value
    }
  },

  selectNewBookingJoinBySchedule(state, payload) {
    const bookingIndex = payload.bookingIndex
    const join = payload.join

    const newBooking = state.newBookings[bookingIndex]
    if (newBooking) {
      _.forEach(newBooking.joins, item => {
        if (item.id !== join.joinID) {
          item.active = false
        }
      })

      const currentJoin = _.find(newBooking.joins, item => {
        if (item.id === join.joinID) {
          item.ranges = [join.begin_at, join.end_at]
          return true
        }
      })

      if (currentJoin) {
        _.forEach(currentJoin.windows, item => {
          if (!_.isEqual(item, join)) {
            item.active = false
          } else {
            item.active = !join.active
            currentJoin.active = join.active
          }
        })
      }
    }
  },

  setNewBookingFieldByIndex(state, payload) {
    const index = payload.index
    const key = payload.key
    const value = payload.value

    const newBooking = state.newBookings[index]
    if (newBooking) {
      newBooking[key] = value
    }
  },

  resetNewBookingByIndex(state, payload) {
    const index = payload.index
    const size = payload.size
    const newBooking = state.newBookings[index]

    if (newBooking) {
      newBooking.finish = false
      newBooking.size = size
    }
  },
  setBookingPaymentHistory(state, payload) {
    state.bookingPaymentHistory = payload
  },
  setBookingHistory(state, payload) {
    state.bookingHistory = payload
  },
}
